module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-list', {
    attrs: {
      "media-list": ""
    }
  }, _vm._l((_vm.inMessages), function(inMessage) {
    return _c('li', {}, [_c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(_vm.getNameLabelDirection(inMessage)))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_c('span', {
      staticClass: "dashboardActionMontant"
    }, [_vm._v(_vm._s(_vm.getSymbol(inMessage.dir)) + " " + _vm._s(inMessage.amt) + " €")])])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "statusLabel"
    }, [_vm._v(_vm._s(_vm.getDirection(inMessage.dir)))]), _vm._v(" "), _c('div', {
      staticClass: "timeLabel"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(inMessage.reqstdExecDt)))])])])])])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28d9ce2f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28d9ce2f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/dashboardComponents/DashboardList.vue
// module id = 1644
// module chunks = 2